function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable */
export default {
  getSignedURL: function getSignedURL(file, config) {
    var payload = {
      filePath: file.name,
      contentType: file.type
    };
    return new Promise(function (resolve, reject) {
      var fd = new FormData();
      var request = new XMLHttpRequest();
      var signingURL = typeof config.signingURL === 'function' ? config.signingURL(file) : config.signingURL;
      request.open('POST', signingURL);

      request.onload = function () {
        if (request.status == 200) {
          resolve(JSON.parse(request.response));
        } else {
          reject(request.statusText);
        }
      };

      request.onerror = function (err) {
        console.error('Network Error : Could not send request to AWS (Maybe CORS errors)');
        reject(err);
      };

      if (config.withCredentials === true) {
        request.withCredentials = true;
      }

      Object.entries(config.headers || {}).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        request.setRequestHeader(name, value);
      });
      payload = Object.assign(payload, config.params || {});
      Object.entries(payload).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            value = _ref4[1];

        fd.append(name, value);
      });
      request.send(fd);
    });
  },
  sendFile: function sendFile(file, config, is_sending_s3) {
    var handler = is_sending_s3 ? this.setResponseHandler : this.sendS3Handler;
    return this.getSignedURL(file, config).then(function (response) {
      return handler(response, file);
    })["catch"](function (error) {
      return error;
    });
  },
  setResponseHandler: function setResponseHandler(response, file) {
    file.s3Signature = response.signature;
    file.s3Url = response.postEndpoint;
  },
  sendS3Handler: function sendS3Handler(response, file) {
    var fd = new FormData();
    var signature = response.signature;
    Object.keys(signature).forEach(function (key) {
      fd.append(key, signature[key]);
    });
    fd.append('file', file);
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.open('POST', response.postEndpoint);

      request.onload = function () {
        if (request.status == 201) {
          var s3Error = new window.DOMParser().parseFromString(request.response, 'text/xml');
          var successMsg = s3Error.firstChild.children[0].innerHTML;
          resolve({
            success: true,
            message: successMsg
          });
        } else {
          var s3Error = new window.DOMParser().parseFromString(request.response, 'text/xml');
          var errMsg = s3Error.firstChild.children[0].innerHTML;
          reject({
            success: false,
            message: "".concat(errMsg, ". Request is marked as resolved when returns as status 201")
          });
        }
      };

      request.onerror = function (err) {
        var s3Error = new window.DOMParser().parseFromString(request.response, 'text/xml');
        var errMsg = s3Error.firstChild.children[1].innerHTML;
        reject({
          success: false,
          message: errMsg
        });
      };

      request.send(fd);
    });
  }
};